import { FC } from 'react'
import { Popover, Tooltip, Whisper } from 'rsuite'
import { OverlayTriggerType } from 'rsuite/esm/Overlay/OverlayTrigger'

import styles from '../../styles/CustomPricing.module.less'

interface NameTagProps {
  name: string
  trigger?: OverlayTriggerType
  tooltipText?: string
  showTooltip?: boolean
  customStyle?: string
}

const NameTag: FC<NameTagProps> = (props) => {
  const {
    name,
    tooltipText,
    trigger = 'hover',
    showTooltip = true,
    customStyle = '',
  } = props
  const firstChar = name?.[0]?.toLocaleUpperCase()

  return (
    <Whisper
      trigger={tooltipText ? trigger : 'none'}
      placement="bottom"
      speaker={(
        <Tooltip
          className={`${!showTooltip ? styles['hide-tooltip'] : ''}}`}
          arrow={false}
          as={Popover}
        >
          <p>{tooltipText}</p>
        </Tooltip>
      )}
    >
      <p className={`${styles['name-tag']} ${customStyle}`}>
        {firstChar}
      </p>
    </Whisper>
  )
}

export default NameTag
